import React, {useContext} from 'react';
import {Context} from "../ApiClient";
import Event from "./Event";
import Filters from "./Filters";

export default function EventList() {

    // Getting object containing events from context, so we need to use braces
    const {events}                          = useContext(Context);
    let [filteredEvents, setFilteredEvents] = React.useState([])

    function CallbackActiveFilters(filters) {
        filterEvents(events, filters);
    }

    function filterEvents(events, filters) {

        // ignore if events is not an array
        if (!Array.isArray(events)) {
            return 1;
        }

        let filteredEvents = events.filter((event) => {
            // Manipulate arrays to compare them
            let eventTerritories = event.territories.split(', ');

            // array unique eventTerritories
            eventTerritories = eventTerritories.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            let eventThemes      = event.themes.split(', ');
            let eventMonth       = new Date(event.date).getMonth();
            let eventMonthEnd    = new Date(event.date_end).getMonth();
            let eventYear        = new Date(event.date).getFullYear();
            let eventYearEnd     = new Date(event.date_end).getFullYear();

            let filterTerritories = [];
            filters.activeTerritories.forEach((filterTerritory) => {
                // split the territory string to get the territory name and the territory parent
                let territories = filterTerritory.value.split(', ');

                //for each territory, push it in the filterTerritories array
                territories.forEach((territory) => {
                    filterTerritories.push(territory);
                });
            });

            // array unique filterTerritories
            filterTerritories = filterTerritories.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });

            let filterThemes      = filters.activeThemes.map(filterThemes => filterThemes.value);
            let filterDate        = filters.activeDate;

            // If event is longer than one month and the filter date is in the middle of the event
            // If monthMode is false, then we compare years only
            // If monthMode is true, then we compare years and months
            let matchDate =
                    (
                        !filters.monthMode
                            // eslint-disable-next-line
                        ||
                        (filterDate.getMonth() >= eventMonth || eventYear < filterDate.getFullYear())
                        // eslint-disable-next-line
                        &&
                        (filterDate.getMonth() <= eventMonthEnd || eventYearEnd > filterDate.getFullYear())
                    )
                        &&
                        (filterDate.getFullYear() >= eventYear && filterDate.getFullYear() <= eventYearEnd);

            const filteredTerritories = eventTerritories.filter(value => filterTerritories.includes(value));
            const filteredThemes      = eventThemes.filter(value => filterThemes.includes(value));

            // If filter is empty, then we return true, else we return true if the event contains the filter and the date is correct
            return (!filterTerritories.length || filteredTerritories.length)
                && (!filterThemes.length || filteredThemes.length)
                && matchDate;
        });


        let searchValues  = filters.searchValue.split(' ');
        searchValues      = searchValues.filter(word => word.length > 2);

        // Recherche d'un des mots clés de la barre de recherche dans le titre ou le corps de l'événement
        if (searchValues.length !== 0) {
            filteredEvents = filteredEvents.filter(event =>
                (searchValues.some(searchValue => event.title.toUpperCase().includes(searchValue.toUpperCase()))
                    ||
                    searchValues.some(searchValue => event.body.toUpperCase().includes(searchValue.toUpperCase()))));
        }


        setFilteredEvents(filteredEvents);
    }

    return (
        // if events is not empty, then render the event list
        <div className="container">
            <div className="">
                <Filters handleCallback={CallbackActiveFilters}/>
                <table className="fc-list-table">
                    <tbody style={!filteredEvents?.length ? {display: "table-cell"} : {}}>
                    {
                        !filteredEvents?.length ? <tr className="no-content">
                            <td>
                                <div>Aucun événement à afficher</div>
                            </td>
                        </tr> : null
                    }
                    {
                        filteredEvents && filteredEvents.map((event) => (
                            <Event event={event} key={event.title}/>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </div>
    )
}